import React from 'react'
import { Controller } from 'react-hook-form'
import { FormGroup, Typography } from '@mui/material'

//components
import Select from 'components/select'
//constants
import { PLATFORMS_ARRAY } from 'constants/index'
//types
import { PlatformSelectContentProps } from 'types'

const PlatformSelectContent = ({ handleSubmit, onSubmit, control }: PlatformSelectContentProps) => {
  return (
    <div className="eligibilityGateContent">
      <Typography variant="body1">
        Before you get started we need a little more info to give you the best experience.
      </Typography>
      <form className="eligibilityGateForm" onSubmit={handleSubmit(onSubmit)}>
        <FormGroup>
          <Controller
            control={control}
            name="platform"
            rules={{
              required: {
                value: true,
                message: 'Platform selection is required',
              },
            }}
            render={({ field: { onChange, value } }) => (
              <Select currentItem={value} options={PLATFORMS_ARRAY} onChange={onChange} />
            )}
          />
        </FormGroup>
      </form>
    </div>
  )
}

export default PlatformSelectContent
